import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  return createRouter({
    routeTree,
    // Follow Vite's base so the router resolves URLs correctly when the build is
    // served from a sub-path (the CMS staging URL, /published/{id}/) rather than
    // a domain root. Resolves to "/" for root-base builds, which is a no-op.
    basepath: import.meta.env.BASE_URL,
    scrollRestoration: true,
    defaultPreload: "intent",
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
